export default __webpack_public_path__ + "static/media/shield.80663a32.png";